import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { RiFileCopyLine } from 'react-icons/ri';
import { toast } from 'react-toastify';
import usePrintPDF from '../../../../services/commonServices/usePrintPDF';

function CreatePDFModal({ isCreatePDFModalOpen, setIsCreatePDFModalOpen,selectedRows,setSelectedRows,printPDFResponse,refetchData }) {
  const handleClose = () => setIsCreatePDFModalOpen(false);
  const { printPDF, isPrintPDFLoading } = usePrintPDF(setSelectedRows);


     // create order return pdf function 
     const handleCreatePDF = () => {
        const orderReturnId = printPDFResponse?.responseData?.orderReturnId?.toString();
        if (!orderReturnId) {
            toast.error('Order return id is missing. Please create packing slip first.');
            return;
        }

        const selectedRowFacId = selectedRows?.find((item) => (
            item?.facId !== undefined && item?.facId !== null && item?.facId !== ''
        ))?.facId;

        if (!selectedRowFacId) {
            toast.error('Facility id is missing from the selected row.');
            return;
        }

        printPDF(
            {
                url: `/orderReturns/generate-pdf`,
                fileName: 'Export PDF.pdf',
                downloadOnSuccess: true,
                payload: {
                    facId: selectedRowFacId,
                    orderReturnId,
                    items: (selectedRows || []).map((item) => ({
                        rxNo: item.rxNumber,
                        returnAmount: item.amount.toString(),
                    })),
                },
            },
            {
                onSuccess: () => {
                    handleClose();
                    refetchData();
                    window.location.reload();
                },
            }
        );
    };


  return (
    <Modal isOpen={isCreatePDFModalOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose} className="border-bottom-0 pb-0">
        <h5
          className="mb-0 font-weight-bold"
          style={{ fontSize: '18px', color: 'black' }}>
          Export PDF File
        </h5>
      </ModalHeader>
      <hr style={{ margin: '0px' }} />
      <ModalBody className="pt-3">
        <div className="d-flex align-items-start gap-3">
          <div className="d-flex align-items-center justify-content-center" style={{ minWidth: '60px' }}>
            <div
              style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#ee2957',
                background: 'linear-gradient(135deg, #6952AD 0%,rgb(192, 177, 236) 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#ffc0cb',
                  background: 'rgb(210, 201, 238)',
                }}>
                <RiFileCopyLine style={{ fontSize: '28px', color: '#6952AD' }} />
              </div>
            </div>
          </div>

          <div className="flex-grow-1 d-flex flex-column gap-2 ml-2">
            <h5 className="font-weight-bold" style={{ fontSize: '16px', color: 'black', marginBottom: '0' }}>
            Create Order Return record PDF
            </h5>
            <p className="text-muted mb-0" style={{ fontSize: '14px', lineHeight: '1.5' }}>
              After creating the packing slip record, it will be removed automatically.
              If you want to create the PDF, click <b style={{ color: '#6952AD' }}>Create PDF</b>.
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="border-top-0 pt-0">
        <Button
          color="gray"
          onClick={handleCreatePDF}
          disabled={isPrintPDFLoading}
          style={{
            cursor: 'pointer',
            borderRadius: '5px',
            padding: '10px 20px',
            color: 'white',
            border: 'none',
            backgroundColor: '#6952AD',
          }}
          className="btn-sm"
        >
          {isPrintPDFLoading ? 'Creating...' : 'Create PDF'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CreatePDFModal;
